import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { actionCommon } from "../redux/actions";
import { useAlert } from "../contexts";

const useAutoLogout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { showAlert } = useAlert();

    useEffect(() => {
        let logoutTimeout;

        const checkSession = () => {
            const userSession = JSON.parse(localStorage.getItem("doctor_access"));

            if (userSession && userSession.expiry) {
                const now = new Date().getTime();
                const timeLeft = userSession.expiry - now;

                if (timeLeft <= 0) {
                    handleLogout();
                } else {
                    // Set timeout only if there is time left
                    logoutTimeout = setTimeout(handleLogout, timeLeft);
                }
            }
        };

        const handleLogout = () => {
            dispatch(actionCommon.logout());
            localStorage.removeItem("doctor_access");
            navigate("/doctor/login");
            showAlert("secondary", "Session expired. Please log in again.", "Info !");
        };

        // Reset logout timer on user activity (e.g., mouse move, key press)
        const resetTimer = () => {
            clearTimeout(logoutTimeout); // Clear the existing timeout
            checkSession(); // Re-check session and start a new timeout
        };

        // Event listeners to track user activity
        document.addEventListener("mousemove", resetTimer);
        document.addEventListener("keydown", resetTimer);

        // Initial session check
        checkSession();

        // Clean up event listeners and timeout on unmount
        return () => {
            clearTimeout(logoutTimeout);
            document.removeEventListener("mousemove", resetTimer);
            document.removeEventListener("keydown", resetTimer);
        };
    }, [dispatch, navigate, showAlert]);
};

export default useAutoLogout;

